import { dataPaintBucket } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaintBucket = /*#__PURE__*/createIcon(dataPaintBucket)
export default IconPaintBucket
